import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IAspectRatioBoxProps extends IBaseProps {
  width: number;
  height: number;
}

const getPaddingBottom = (width: number, height: number): string => `${(height / width) * 100}%`;

const AspectRatioBox: React.FC<IAspectRatioBoxProps> = (props) => {
  const { style, className, width, height, children } = props;

  return (
    <div
      style={{ ...style, paddingBottom: getPaddingBottom(width, height) }}
      className={classnames('dbg-aspect-ratio-box', className)}
    >
      <div className="dbg-aspect-ratio-box__inner">{React.isValidElement(children) && children}</div>
    </div>
  );
};

export default React.memo(AspectRatioBox);
